module.exports = ".panel__header-text {\n  color: #2C3031;\n}"